import axios from "../../../util/axios";

const PREFIX_URI = "/project/dev/dashboard";

export default {
    /** 仪表盘总览 */
    overview: (data) => axios.get({url: `${PREFIX_URI}/overview`, data: data}),
};
